// `profiles` has no table-level SELECT grant — the RLS lockdown REVOKEd ALL and
// granted a column list instead (20260806010000_rls_lockdown.sql), because
// hiding `email` and `ip_address` is a column concern and RLS is row-level.
//
// Postgres expands `SELECT *` before checking privileges, so `select('*')` on
// this table is a hard `42501 permission denied for table profiles` for EVERY
// role, including admins — not an empty result. PostgREST passes `*` straight
// through, so the same is true inside an embed (`profiles!fk(*)`).
//
// This is the exact list `authenticated` and `anon` may read. Use it instead of
// `*` in every profiles select and embed. If a column is added to profiles and
// the client needs it, it needs a GRANT too — adding it here alone does nothing.
export const PROFILE_SELECT_COLUMNS = [
  'id',
  'name',
  'username',
  'display_name',
  'avatar_url',
  'bio',
  'website',
  'show_name',
  'badges',
  'created_at',
  'is_commercial_user',
  'public_cards_number',
  'private_cards_number',
  'is_deleted',
].join(', ');
